import React from 'react';

export default function PlatformSection() {
  return (
    <section className="platform-section-corporate">
      <div className="container">
        <div className="platform-item">
          <div className="platform-item__title">
            <span>
              Independent <br />
              Contractor <br />
              Compliance
            </span>
            <div className="mirror">Compliance</div>
          </div>
          <ul className="platform-item__list">
            <li>
              Source and engage candidates while maintaining full compliance
            </li>
            <li>We classify and assume worker liability</li>
            <li>Insurance validation for independent contractors</li>
          </ul>
        </div>
        <div className="platform-item platform-item--2">
          <div className="platform-item__title">
            <span>
              Talent <br />
              Network <br />
              Platform
            </span>
            <div className="mirror">Platform</div>
          </div>
          <ul className="platform-item__list platform-item__list--right">
            <li>Target specialty recruiters in niche domains</li>
            <li>Expand your reach nationally and globally</li>
            <li>Full visibility into the entire hiring lifecycle</li>
            <li>Control settings for recruiter engagement</li>
          </ul>
        </div>
        <div className="platform-item platform-item--3">
          <div className="platform-item__title">
            <span>
              Direct <br />
              Sourcing
            </span>
            <div className="mirror">Sourcing</div>
          </div>
          <ul className="platform-item__list">
            <li>Cost-effective solution for direct candidate engagement</li>
            <li>Build and grow your own talent</li>
            <li>Branded experience that matches your company culture</li>
            <li>Self-sourced talent through direct engagement</li>
          </ul>
        </div>
      </div>
    </section>
  );
}
